// Number / currency formatters — ported from design/v3/AnalyticsBits.jsx.

export function fmtWon(n: number): string {
  return '₩' + Math.round(n).toLocaleString('ko-KR');
}

export function fmtWonShort(n: number): string {
  if (n >= 100_000_000)
    return `₩${(n / 100_000_000).toFixed(1).replace(/\.0$/, '')}억`;
  if (n >= 10_000)
    return `₩${Math.round(n / 10_000).toLocaleString('ko-KR')}만`;
  return `₩${Math.round(n).toLocaleString('ko-KR')}`;
}

export function fmtNum(n: number): string {
  return Math.round(n).toLocaleString('ko-KR');
}

export function fmtPct(n: number, digits = 1): string {
  return `${n.toFixed(digits)}%`;
}

export function fmtDelta(curr: number, prev: number) {
  if (!prev) return { pct: 0, text: '0.0%', positive: true };
  const d = ((curr - prev) / prev) * 100;
  return {
    pct: d,
    text: (d >= 0 ? '+' : '') + d.toFixed(1) + '%',
    positive: d >= 0,
  };
}

const platformColorMap: Record<string, string> = {
  baemin: 'var(--platform-baemin)',
  coupang: 'var(--platform-coupang)',
  yogiyo: 'var(--platform-yogiyo)',
};

const platformShortMap: Record<string, string> = {
  baemin: '배민',
  coupang: '쿠팡',
  yogiyo: '요기요',
};

export function platformColor(id: string | null | undefined): string {
  if (!id) return 'var(--fg-4)';
  return platformColorMap[id] ?? 'var(--fg-4)';
}

export function platformShort(id: string | null | undefined): string {
  if (!id) return '-';
  return platformShortMap[id] ?? id;
}

export function platformName(id: string | null | undefined): string {
  if (!id) return '-';
  if (id === 'baemin') return '배달의민족';
  if (id === 'coupang') return '쿠팡이츠';
  if (id === 'yogiyo') return '요기요';
  return id;
}
